export default __webpack_public_path__ + "static/media/hero2026.50e8e7e9.png";